export const APPLY_USER = "APPLY_USER";
export const APPLY_MENU = "APPLY_MENU";